import React, { createContext, useContext } from 'react'
import styled, { ThemeProvider } from 'styled-components'
import { Theme } from '../../constants/Config'
import Router from '../../containers/RouterContainer'
import { ConfigStore } from '../../model/Store/ConfigStore'
import Clock from './Clock/Clock'
import kiwiLogo from './ki-wi.png'
import NoContent from './NoContent/NoContent'

const ConfigContext = createContext(new ConfigStore())

export const useConfigContext = (): ConfigStore => useContext(ConfigContext)

const Wrapper = styled.div`
  background: ${(props) => props.theme.colorBg};
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

const Header = styled.header`
  height: 9.4rem;
  margin-top: .7rem;
  color: white;
  display: flex;
  flex-wrap: wrap;

  @media screen and (orientation: portrait) {
    height: 8.6rem;
  }
`

const ClientLogo = styled.img`
  margin: 1.8rem 2rem 2.5rem auto;
  height: 4.4rem;
`

const Content = styled.div`
  flex: 1;
  padding: 0 2rem;
  display: flex;
  max-width: 100%;
`

const Footer = styled.footer`
  display: flex;
  height: 5.8rem;
`

const KiwiLogo = styled.img`
  width: 8.2rem;
  margin: 2rem 2rem auto auto;
`

const themes = (theme: Theme) => {
  switch (theme) {
    case Theme.DarkBlue:
      return {
        colorBg: '#142b3e',
        colorProgressBg: '#004d5b',
        colorProgressBar: '#00aac9',
        colorArrows: '#00aac9',
      }
    case Theme.Blue:
      return {
        colorBg: '#1a5f8b',
        colorProgressBg: '#134464',
        colorProgressBar: '#74b4c2',
        colorArrows: '#00aac9',
      }
    case Theme.Purple:
      return {
        colorBg: '#1f0022',
        colorProgressBg: '#320036',
        colorProgressBar: '#55005c',
        colorArrows: '#55005c',
      }
    case Theme.Brown:
      return {
        colorBg: '#25160d',
        colorProgressBg: '#3b1d0c',
        colorProgressBar: '#64361c',
        colorArrows: '#3b1d0c',
      }
    case Theme.GreenGradient:
      return {
        colorBg: 'linear-gradient(45deg, #01716c 0%, #036c42 100%)',
        colorProgressBg: '#104d2a',
        colorProgressBar: '#25c17a',
        colorArrows: '#008761',
      }
    default:
      return {
        colorBg: '#1a5f8b',
        colorProgressBg: '#134464',
        colorProgressBar: '#74b4c2',
        colorArrows: '#00aac9',
      }
  }
}

const App = (props: ConfigStore) => {
  const { clientLogoPath, initialized, theme } = props

  return (
    <ThemeProvider theme={themes(theme)}>
      <ConfigContext.Provider value={props}>
        <Wrapper>
          <Header>
            <Clock/>
            {clientLogoPath && <ClientLogo src={clientLogoPath} alt="client logo"/>}
          </Header>
          <Content>
            {!initialized ? (
              <NoContent/>
            ) : (
              <Router/>
            )}
          </Content>
          <Footer>
            <KiwiLogo src={kiwiLogo} alt="Ki-Wi logo"/>
          </Footer>
        </Wrapper>
      </ConfigContext.Provider>
    </ThemeProvider>
  )
}

export default App
